import { Component, Input } from '@angular/core';

import { TableCellData } from '@site-mate/dashpivot-shared-library';

import { TemplateTableCellComponent } from './table-cell.component';

@Component({
  template: '<div></div>',
})
export class TemplateTableGenericCellComponent implements TemplateTableCellComponent {
  @Input() cellData: TableCellData;
}
